import { render, staticRenderFns } from "./duoToolkit.vue?vue&type=template&id=97677912&scoped=true&"
import script from "./duoToolkit.vue?vue&type=script&lang=js&"
export * from "./duoToolkit.vue?vue&type=script&lang=js&"
import style0 from "./duoToolkit.vue?vue&type=style&index=0&id=97677912&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97677912",
  null
  
)

export default component.exports